import { browserSupportsWebAuthn, browserSupportsWebAuthnAutofill } from "@simplewebauthn/browser";
import React, { useEffect } from "react";
import { useApp } from "../../../hooks/app-context";
import { useConfig } from "../../../hooks/config-context";
import { DividerComponent } from "../../shared/DividerComponent";
import { PasskeysLoginButtonComponent } from "../shared/PasskeysLoginButtonComponent";
import { useTranslation } from "react-i18next";
import { SsoButtonsComponent } from "./SsoButtonsComponent";
import { useState } from "react";
import { MagicLinkLoginButtonComponent } from "../shared/MagicLoginButtonComponent";
const LoginAlternativesComponent = ({
  didClickPasskeysAuthenticate,
  didClickMagicLinkAuthenticate,
  didClickSocialLogin
}) => {
  const {
    t
  } = useTranslation();
  const {
    authLegacy
  } = useConfig();
  const {
    passkeysEnabled,
    magicLinkEnabled
  } = useApp();
  const [hasSsoAlternatives, setHasSsoAlternatives] = useState(false);
  const doPasskeysLogin = !authLegacy && passkeysEnabled && browserSupportsWebAuthn();
  useEffect(() => {
    if (doPasskeysLogin) {
      browserSupportsWebAuthnAutofill().then(support => {
        if (support) {
          didClickPasskeysAuthenticate(true);
        }
      });
    }
  }, []);
  const renderPasskeysLogin = () => {
    if (doPasskeysLogin) {
      return /*#__PURE__*/React.createElement(PasskeysLoginButtonComponent, {
        mode: "login",
        onClick: () => didClickPasskeysAuthenticate(false)
      });
    }
  };
  const renderMagicKeyLogin = () => {
    if (magicLinkEnabled) {
      return /*#__PURE__*/React.createElement(MagicLinkLoginButtonComponent, {
        mode: "login",
        onClick: () => didClickMagicLinkAuthenticate()
      });
    }
  };
  const hasAlternatives = doPasskeysLogin || magicLinkEnabled || hasSsoAlternatives;
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasAlternatives && /*#__PURE__*/React.createElement("div", {
    className: "py-2"
  }, /*#__PURE__*/React.createElement(DividerComponent, {
    text: t("Or")
  })), /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, renderPasskeysLogin(), renderMagicKeyLogin(), /*#__PURE__*/React.createElement(SsoButtonsComponent, {
    label: "login",
    didClickSsoBtn: didClickSocialLogin,
    hasAlternatives: setHasSsoAlternatives
  })));
};
export { LoginAlternativesComponent };